import { Minus, Plus, Printer, RotateCcw } from 'lucide-react'
import { useState, type FormEvent } from 'react'

type ManualItem = { id:number; quantity:number; description:string }

const escHtml=(value:unknown)=>String(value??'').replace(/[&<>"']/g,char=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]||char))

export function ManualExit() {
  const [customerName,setCustomerName]=useState('')
  const [tableName,setTableName]=useState('')
  const [items,setItems]=useState<ManualItem[]>([{id:1,quantity:1,description:''}])
  const [error,setError]=useState('')

  function updateItem(id:number,field:'quantity'|'description',value:string|number){
    setItems(current=>current.map(item=>item.id===id?{...item,[field]:field==='quantity'?Math.max(1,Number(value)||1):value}:item))
  }

  function addItem(){
    setItems(current=>[...current,{id:Date.now(),quantity:1,description:''}])
  }

  function removeItem(id:number){
    setItems(current=>current.length===1?current:current.filter(item=>item.id!==id))
  }

  function clearForm(){
    setCustomerName('')
    setTableName('')
    setItems([{id:Date.now(),quantity:1,description:''}])
    setError('')
  }

  function printExit(event:FormEvent){
    event.preventDefault()
    const name=customerName.trim()
    const table=tableName.trim()
    const validItems=items.filter(item=>item.description.trim())
    if(name.length<2){setError('Informe o nome da pessoa.');return}
    if(!table){setError('Informe a mesa. Pode escrever "Sem número".');return}
    if(!validItems.length){setError('Adicione pelo menos um pedido/item.');return}
    setError('')

    const rows=validItems.map(item=>`<div class="item"><b>${item.quantity}x</b><span>${escHtml(item.description)}</span></div>`).join('')
    const now=new Date().toLocaleString('pt-BR')
    const html=`<!doctype html><html><head><meta charset="utf-8"><title>Saída liberada - ${escHtml(name)}</title><style>@page{size:80mm auto;margin:3mm}*{box-sizing:border-box}body{font-family:Arial,sans-serif;width:74mm;margin:0 auto;color:#000;font-size:13px}h1{text-align:center;font-size:17px;margin:0 0 3px}.exit{border:3px double #000;text-align:center;font-size:22px;font-weight:900;padding:9px;margin:9px 0}.meta{border-bottom:2px dashed #000;padding:7px 0;margin-bottom:7px}.meta div{display:flex;justify-content:space-between;gap:8px;margin:4px 0}.person{font-size:17px}.items-title{font-weight:900;margin:8px 0 4px}.item{display:flex;gap:8px;padding:7px 0;border-bottom:1px dashed #777;font-size:15px}.item b{min-width:28px}.footer{text-align:center;margin-top:12px;font-size:10px}</style></head><body><h1>GONÇALO MUSIC BAR</h1><div class="exit">✓ SAÍDA LIBERADA</div><div class="meta"><div class="person"><span>NOME</span><b>${escHtml(name)}</b></div><div><span>MESA</span><b>${escHtml(table)}</b></div><div><span>DATA / HORA</span><b>${escHtml(now)}</b></div></div><div class="items-title">PEDIDOS / ITENS</div>${rows}<div class="footer">Controle manual de saída<br>Documento não fiscal</div><script>window.onload=()=>{window.print();setTimeout(()=>window.close(),850)}<\/script></body></html>`
    const win=window.open('','_blank','width=420,height=760')
    if(!win){setError('O navegador bloqueou a impressão. Libere pop-ups para este site.');return}
    win.document.open()
    win.document.write(html)
    win.document.close()
  }

  return <>
    <div className="page-heading">
      <div><span className="eyebrow dark">CONTROLE MANUAL</span><h1>Saída</h1><p>Preencha nome, mesa e os pedidos. Depois imprima a liberação de saída.</p></div>
    </div>

    <section className="panel" style={{maxWidth:760,margin:'0 auto'}}>
      <div className="panel-heading"><div><span className="eyebrow dark">SAÍDA DA PESSOA</span><h3>Nova saída manual</h3></div><button type="button" className="ghost-button" onClick={clearForm}><RotateCcw size={17}/> Limpar</button></div>
      <form className="entity-form" onSubmit={printExit}>
        <div className="form-grid">
          <label>Nome da pessoa<input value={customerName} onChange={e=>setCustomerName(e.target.value)} placeholder="Ex.: Márcio" required autoFocus/></label>
          <label>Mesa<input value={tableName} onChange={e=>setTableName(e.target.value)} placeholder='Ex.: 12 ou Sem número' required/></label>
        </div>

        <div style={{marginTop:8}}>
          <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',gap:12,marginBottom:10}}>
            <div><strong>Pedidos / itens</strong><small style={{display:'block'}}>Digite manualmente o que a pessoa consumiu.</small></div>
            <button type="button" className="secondary-button small" onClick={addItem}><Plus size={16}/> Adicionar item</button>
          </div>
          <div style={{display:'grid',gap:10}}>
            {items.map((item,index)=><div key={item.id} style={{display:'grid',gridTemplateColumns:'82px minmax(0,1fr) 42px',gap:8,alignItems:'end'}}>
              <label>Qtd.<input type="number" min="1" max="99" value={item.quantity} onChange={e=>updateItem(item.id,'quantity',e.target.value)}/></label>
              <label>Pedido / item<input value={item.description} onChange={e=>updateItem(item.id,'description',e.target.value)} placeholder={index===0?'Ex.: 1 porção de batata / Coca-Cola':''}/></label>
              <button type="button" className="ghost-button" style={{height:46,padding:0}} onClick={()=>removeItem(item.id)} disabled={items.length===1} aria-label="Remover item"><Minus size={18}/></button>
            </div>)}
          </div>
        </div>

        {error&&<div className="form-error" role="alert">{error}</div>}
        <div className="settings-tip"><Printer size={18}/><span>A impressão sai em formato térmico de 80 mm com <strong>SAÍDA LIBERADA</strong>, nome, mesa, horário e todos os itens digitados.</span></div>
        <div className="form-actions"><button type="button" className="ghost-button" onClick={clearForm}>Limpar</button><button className="primary-button"><Printer size={18}/> Imprimir saída</button></div>
      </form>
    </section>
  </>
}
